import React from 'react'
import {
  useCurrentArtboard,
  useNavigation,
  useUndoRedo,
} from '@sketch-hq/sketch-prototype-player'
import { Tooltip, TooltipShortcut } from '@sketch/components'
import {
  Container,
  Divider,
  Button,
  RestartIcon,
  GoForwardsButton,
  GoBackwardsButton,
} from './PrototypeControls.styles'
import { usePrototypeStartArtboardId } from '../../hooks'

type HistoryNavigationProps = {
  className?: string
}

export function PrototypeControls({ className }: HistoryNavigationProps) {
  const { restartPrototypeFrom } = useNavigation()
  const { undo, redo, canUndo, canRedo } = useUndoRedo()
  const prototypeStartArtboardId = usePrototypeStartArtboardId()
  const currentArtboard = useCurrentArtboard()

  // Reset can be done to go back to the first artboard of the prototype
  // or in the case of overlays (that stay on same artboard), when the user can undo anything.
  const canReset = prototypeStartArtboardId !== currentArtboard?.id || canUndo

  return (
    <Container className={className}>
      <Tooltip
        placement="bottom"
        disableWhenTouchDevice
        content={
          <>
            Restart Prototype
            <TooltipShortcut>Press R</TooltipShortcut>
          </>
        }
        disabled={!canReset}
      >
        <Button
          type="button"
          aria-label="Restart prototype"
          disabled={!canReset}
          onClick={() => restartPrototypeFrom(prototypeStartArtboardId)}
        >
          <RestartIcon />
        </Button>
      </Tooltip>
      <Divider />
      <Tooltip
        placement="bottom"
        disableWhenTouchDevice
        content={
          <>
            Go Back
            <TooltipShortcut>Press left arrow</TooltipShortcut>
          </>
        }
        disabled={!canUndo}
      >
        <Button
          type="button"
          aria-label="Undo prototype action"
          disabled={!canUndo}
          onClick={undo}
        >
          <GoBackwardsButton />
        </Button>
      </Tooltip>
      <Tooltip
        disableWhenTouchDevice
        placement="bottom"
        content={
          <>
            Go Forward
            <TooltipShortcut>Press right arrow</TooltipShortcut>
          </>
        }
        disabled={!canRedo}
      >
        <Button
          type="button"
          aria-label="Redo prototype action"
          disabled={!canRedo}
          onClick={redo}
        >
          <GoForwardsButton />
        </Button>
      </Tooltip>
    </Container>
  )
}
